module.exports = __webpack_public_path__ + "img/expectations_rights.12d01550.jpg";